import { render, staticRenderFns } from "./IntradayBox.vue?vue&type=template&id=20f1f50a&scoped=true"
import script from "./IntradayBox.vue?vue&type=script&lang=js"
export * from "./IntradayBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1f50a",
  null
  
)

export default component.exports